import React from "react";
import { Helmet } from "react-helmet-async";

export default function ShippingPolicy() {
  return (
    <main className="max-w-4xl mx-auto px-6 py-16">
      {/* ============================
          SEO
      ============================ */}
      <Helmet>
        <title>Shipping Policy | Aerzen Air™</title>
        <meta
          name="description"
          content="Read Aerzen Air™ shipping policy including delivery timelines, shipping coverage within India, charges, and delay conditions."
        />
        <link
          rel="canonical"
          href="https://www.aerzenair.com/shipping"
        />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">Shipping Policy</h1>

      <p className="text-gray-700 mb-4">
        AERZEN AIR™ currently ships products within India only.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Delivery Timeline</h2>
      <p className="text-gray-700 mb-4">
        AERZEN AIR™ products are offered on a pre-booking basis. Delivery is
        expected within approximately{" "}
        <strong>14 weeks from the date of successful pre-booking
        confirmation</strong>.
      </p>

      <p className="text-gray-700 mb-4">
        Delivery timelines may vary based on production schedules, quality
        assurance processes, regulatory approvals, logistics conditions, and
        order volumes. Customers will be informed in case of any significant
        changes.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Shipping Charges</h2>
      <p className="text-gray-700 mb-4">
        Shipping charges, if applicable, will be communicated during order
        confirmation or checkout. Any applicable charges will be clearly
        disclosed prior to payment.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Delays & Exceptions</h2>
      <p className="text-gray-700 mb-4">
        While we strive to meet all delivery timelines, delays may occur due to
        unforeseen circumstances such as logistics disruptions, force majeure
        events, regulatory requirements, or operational constraints.
      </p>

      <p className="text-gray-700">
        AERZEN AIR™ shall not be held liable for delays beyond reasonable control,
        and such delays do not constitute grounds for cancellation unless
        explicitly stated in the Refund & Cancellation Policy.
      </p>
    </main>
  );
}
